import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { message, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import ReactTable from "../../../../components/common/ReactTable";
import ApiCallService from "../../../../Service/ApiCallService";
import { usePermission } from "../../../../permissions/usePermission";

const JourneyApprovalTable = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { canByKey } = usePermission();
  const canApproveJourneyEdit = canByKey("USER_MANAGEMENT_USER_APPROVAL_APPROVE_JOURNEY_EDIT");
  const canDeclineJourneyEdit = canByKey("USER_MANAGEMENT_USER_APPROVAL_DECLINE_JOURNEY_EDIT");

  const fetchJourneyApprovals = async () => {
    try {
      setLoading(true);
      const res = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/journey/pending`
      );
      setRows(res || []);
    } catch {
      setLoading(false);
      message.error("Failed to fetch journey approvals");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJourneyApprovals();
  }, []);

  const columns = [
    {
      field: "user",
      headerName: "User",
      renderCell: (row) =>
        `${row.userId?.userFirstName} ${row.userId?.userLastName}`,
      searchKey: (row) =>
        `${row.userId?.userFirstName || ""} ${row.userId?.userMiddleName || ""} ${row.userId?.userLastName || ""}`,
    },
    {
      field: "position",
      headerName: "Position",
      renderCell: (row) => row.requestedData?.position,
    },
    {
      field: "type",
      headerName: "Action",
      renderCell: (row) => (
        <Tag color={row.action === "CREATE" ? "green" : "orange"}>
          {row.action}
        </Tag>
      ),
    },
    {
      field: "requestedAt",
      headerName: "Requested On",
      renderCell: (row) =>
        new Date(row.createdAt).toLocaleString(),
    },
    ...((canApproveJourneyEdit || canDeclineJourneyEdit)
      ? [
          {
            field: "actions",
            headerName: "Actions",
            disableSearch: true,
            renderCell: (row) => (
              <Button
                variant="contained"
                onClick={() =>
                  navigate(`/journey-review/${row._id}`)
                }
              >
                Review
              </Button>
            ),
          },
        ]
      : []),
  ];

  return (
    <Box>
      <ReactTable
        columns={columns}
        rows={rows}
        rowKey="_id"
        loading={loading}
      />
    </Box>
  );
};

export default JourneyApprovalTable;
